import { CdnService } from '@/common/services/cdn/cdn.service';
import { RentalPolicyResponse } from '@/core/domain/rental-policy/models/rental-policy-response.model';
import { RentalPolicyRepository } from '@/core/domain/rental-policy/repositories/rental-policy.respository';
import { TranslationsGetLanguageUseCase } from '@/core/domain/translation/usecases/translations-get-language.usecase';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import _ from 'lodash';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class RentalPolicyImplRepository extends RentalPolicyRepository {
    constructor(
        private readonly http: HttpClient,
        private readonly getLanguageUseCase: TranslationsGetLanguageUseCase,
    ) {
        super();
    }

    override getRentalPolicy(): Observable<RentalPolicyResponse> {
        return this.http.get<RentalPolicyResponse>(
            CdnService.url(
                'rental-policy-json/' +
                    this.getLanguageUseCase.execute().language +
                    '.json',
            ),
        );
    }
}
